module.exports = __webpack_public_path__ + "static/media/8B.ab5b6fb8.png";